// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__21Y8w","col":"styles_col__3yUZC","fulfillmentStatus":"styles_fulfillmentStatus__3Aj3m","emailCol":"styles_emailCol__28KM6"};